import { useEffect, useState } from 'react';
import type { SetURLSearchParams } from 'react-router-dom';
import {
  fetchSiteConditionState,
  type ConditionLifecycleSummary,
} from '../../domain/continuousSafety/siteConditionState';

export function useScanConditionLifecycle(args: {
  reportId: string;
  siteId: string;
  requestedConditionId: string;
  setSearchParams: SetURLSearchParams;
}): ConditionLifecycleSummary | null {
  const { reportId, siteId, requestedConditionId, setSearchParams } = args;
  const [conditionLifecycle, setConditionLifecycle] = useState<ConditionLifecycleSummary | null>(null);

  useEffect(() => {
    if (!siteId) {
      setConditionLifecycle(null);
      return undefined;
    }
    let cancelled = false;
    void fetchSiteConditionState({
      siteId,
      conditionIds: requestedConditionId ? [requestedConditionId] : undefined,
    }).then((result) => {
      if (cancelled || result.status !== 'success') {
        if (!cancelled) setConditionLifecycle(null);
        return;
      }
      const match = requestedConditionId
        ? result.data.conditions.find((item) => item.conditionId === requestedConditionId)
        : result.data.conditions.find((item) => {
          const scan = item.conditionLifecycle?.latestScan;
          return scan?.afterReportId === reportId || scan?.beforeReportId === reportId;
        });
      setConditionLifecycle(match?.conditionLifecycle || null);
      const resolvedId = String(match?.conditionId || '').trim();
      if (resolvedId && resolvedId !== requestedConditionId) {
        setSearchParams((current) => {
          const next = new URLSearchParams(current);
          next.set('condition_id', resolvedId);
          return next;
        }, { replace: true });
      }
    });
    return () => {
      cancelled = true;
    };
  }, [requestedConditionId, reportId, setSearchParams, siteId]);

  return conditionLifecycle;
}
